export default __webpack_public_path__ + "static/media/uk-2-flag.4107725a.jpg";